import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { ContainerWithLogo, Button, Loader } from '@app/components';
import {
  getUserDevices, removeUserDevice, removeAllUserDevices, resetDevices,
} from '@app/actions/deviceActions';
import colors from '@app/constants/colors';
import TableDevices from './components/TableDevices';

class Devices extends React.Component {
  componentDidMount() {
    const { getUserDevices } = this.props;
    getUserDevices();
  }

  componentWillUnmount() {
    const { resetDevices } = this.props;
    resetDevices();
  }

  renderNoTableItem = () => {
    const { isDevicesLoading } = this.props;
    if (isDevicesLoading) {
      return <Loader />;
    }
    return <h3><FormattedMessage id="devices.noDevices" /></h3>;
  }

  render() {
    const {
      devices, isDevicesLoading, isDeviceRemoving, isAllDevicesRemoving, removeAllUserDevices,
    } = this.props;

    return (
      <ContainerWithLogo titleLabel="devices.title">
        <DevicesContainer>
          <p><FormattedMessage id="devices.connectAccount" /></p>
          <br />
          <p><FormattedMessage id="devices.tvAccount" /></p>
          <TableTittle><FormattedMessage id="devices.word" /></TableTittle>
          <TableContainer>
            {
              devices && devices.length && !isDevicesLoading
                ? (
                  <React.Fragment>
                    <TableDevices />
                    <ButtonContainer>
                      <Button
                        labelId="devices.removeAll"
                        textColor={colors.ALICE_BLUE}
                        backgroundColor={colors.INTERNATIONAL_ORANGE}
                        onClick={removeAllUserDevices}
                        loading={isAllDevicesRemoving}
                        disabled={isAllDevicesRemoving || isDeviceRemoving}
                      />
                    </ButtonContainer>
                  </React.Fragment>
                )
                : this.renderNoTableItem()
            }
          </TableContainer>
        </DevicesContainer>
      </ContainerWithLogo>
    );
  }
}

Devices.propTypes = {
  getUserDevices: PropTypes.func.isRequired,
  removeAllUserDevices: PropTypes.func.isRequired,
  resetDevices: PropTypes.func.isRequired,
  isDevicesLoading: PropTypes.bool.isRequired,
  isAllDevicesRemoving: PropTypes.bool.isRequired,
  isDeviceRemoving: PropTypes.bool.isRequired,
  devices: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = ({
  device: {
    devices, isDevicesLoading, isAllDevicesRemoving, isDeviceRemoving, idRemovingDevice,
  },
}) => ({
  devices,
  isDevicesLoading,
  isAllDevicesRemoving,
  isDeviceRemoving,
  idRemovingDevice,
});

const mapDispatchToProps = {
  getUserDevices,
  removeUserDevice,
  removeAllUserDevices,
  resetDevices,
};

export default connect(mapStateToProps, mapDispatchToProps)(Devices);

const DevicesContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 960px;
  width: 100%;
  padding: 0 10px;
  color: white;

  & p {
    margin: 0;
  }
`;

const TableTittle = styled.h2`
  max-width: 820px;
  width: 100%;
  border-top: 2px solid;
  margin: 45px auto;
  padding-top: 25px;
  text-transform: uppercase;
`;

const TableContainer = styled.div`
  max-width: 880px;
  padding-bottom: 130px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 115px;
`;
